import { Close } from '@atom-learning/icons'
import * as React from 'react'

import { Chip } from '~/components/chip/Chip'
import { DismissibleGroup } from '~/components/dismissible-group'
import { styled } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'

const StyledChipDismissibleGroupItem = styled(Chip, {
  base: ['flex', 'px-1']
})

export type TChipDismissibleGroupItem = React.ComponentProps<
  typeof DismissibleGroup.Item
> &
  React.ComponentProps<typeof StyledChipDismissibleGroupItem> & {
    dismissActionLabel: string
  }

export const ChipDismissibleGroupItem = ({
  size = 'md',
  children,
  dismissActionLabel = 'Dismiss',
  ...rest
}: TChipDismissibleGroupItem) => {
  return (
    <DismissibleGroup.Item asChild {...rest}>
      <StyledChipDismissibleGroupItem size={size}>
        <Chip.Content>{children}</Chip.Content>
        <DismissibleGroup.Trigger asChild>
          <ActionIcon
            label={dismissActionLabel}
            size={size === 'sm' ? 'xs' : 'sm'}
            className="text-grey-600"
          >
            <Icon is={Close} />
          </ActionIcon>
        </DismissibleGroup.Trigger>
      </StyledChipDismissibleGroupItem>
    </DismissibleGroup.Item>
  )
}
